<script lang="ts">
    import { createEventDispatcher } from "svelte";
    import { Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, TabContent, TabPane } from "sveltestrap";
  import { error, success } from "../../../../../public/my-theme";
  import type { Fn } from "../../../../global";
  import type { Third } from "../../../../Model/Third";
  import type { Witness } from "../../../../Model/Witness";
  import { kinshipsService, witnessGenderService, witnessService } from "../../../../services";
  import WitnessInfoForm from "../../Global/WitnessInfoForm.svelte";
    import type { WitnessGender } from "../../../../Model/WitnessGender";
    import type { Kinship } from "../../../../Model/Kinship";
  
    export let witnessThird: Third;
    export let diligenceId: string;
    export let open = false;
    export let toggle: Fn = undefined;
  
    $: load(diligenceId, witnessThird)
    $: loadKinships();
  
    let size = "lg";
    let witnessGender: WitnessGender;
    let witness: Witness;
    let kinshipParams: Kinship[];
  
    const dispatch = createEventDispatcher();
  
    async function load(diligenceId, denouncedThird){
      if (diligenceId && denouncedThird) {
        let witnessArray: Witness[] = await witnessService.findByDiligenceNumber(diligenceId)
        witness = witnessArray.find(c => c.witnessThird == denouncedThird.id)

        witnessGender = await witnessGenderService.findOneByDiligenceNumber(diligenceId);
      }
    }
  
    async function saveWitness() {
      try {
        save()
        toggle()
        success("Datos guardados con exito");
      } catch (err) {
        error("Comprueba los campos");
      }
    }
  
    async function changeThirdList(third){
      witness.witnessThird = third.id;
      save()
    }
  
    async function save(){
      await witnessGenderService.saveWitness(witness);
  
      dispatch('saveWitness');
    }

    async function loadKinships() {
        kinshipParams = await kinshipsService.find();
    }
  
  </script>
  
  <Modal isOpen={open} {toggle} {size}>
    <ModalHeader {toggle}>Editar</ModalHeader>
    <ModalBody>
      <TabContent>
        <TabPane tabId="Datos" tab="Datos" active>
          {#if witness}
            <WitnessInfoForm witness={witness} on:changeThirdLIst={(event) => changeThirdList(event.detail)}/>
          {/if}
        </TabPane>
        <TabPane tabId='Situacion' tab="Situación">
            {#if witnessGender}
                <div class="mt-3">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="row">
                                <div class="col-9 col-md-10">
                                    Relación con el agresor
                                </div>
                                <div class="col-3 col-md-2">
                                    <select class='form-select' bind:value={witnessGender.aggressorRelationId}>
                                        {#each kinshipParams as kinship}
                                            <option value={kinship.kinship}>{kinship.name}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="row">
                                <div class="col-9 col-md-10">
                                    Relación con la víctima
                                </div>
                                <div class="col-3 col-md-2">
                                    <select class='form-select' bind:value={witnessGender.victimRelationshipId}>
                                        {#each kinshipParams as kinship}
                                            <option value={kinship.kinship}>{kinship.name}</option>
                                        {/each}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-12 mb-3">
                            <Label for="mark">Observaciones</Label>
                            <Input
                              type="textarea"
                              rows={6}
                              bind:value={witnessGender.observations}
                            />
                          </div>
                    </div>
                </div>
            {/if}
        </TabPane>
      </TabContent>
    </ModalBody>
    <ModalFooter>
      <button class="btn btn-success" type="button" on:click={saveWitness}>Guardar</button>
    </ModalFooter>
  </Modal>
  
  